<div class="step-con-box">
    <div class="step-subject-box">
        <div class="main-txt">
            {{ "join.terms.title" | translate }}
        </div>
    </div>
    <article class="sign-in-agree">
        <div class="agree-list">
            <div class="agree-row">
                <div class="agree-chk-box type-all">
                    <div class="cbox">
                        <label>
                            <input type="checkbox" [(ngModel)]="isAllTermsChecked" (click)="toggleAllCheckedState()" />
                            <i></i>
                            <span class="txt">
                                {{ "join.terms.agreeAll" | translate }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="agree-row type-margin">
                <div class="agree-chk-box">
                    <div class="cbox">
                        <label>
                            <input type="checkbox" [(ngModel)]="isTermsOfServiceChecked" (change)="toggleCheckedState(isTermsOfServiceChecked)" />
                            <i></i>
                            <span class="txt">
                                {{ "join.terms.agreeTerms" | translate }}
                            </span>
                        </label>
                    </div>
                </div>
                <div class="agree-terms-box">
                    <div class="dl-group">
                        <div class="dl-tit">
                            제1장 일반 조건
                        </div>
                        <dl>
                            <dt>
                                제1조 (목적)
                            </dt>
                            <dd>
                                본 서비스 약관(이하 “약관”)은 주식회사 아이지아이에스(이하 “회사”) 및 회사 서비스 웹사이트(이하 “서비스”)를 이용하는 고객(이하 “고객”)의 권리와 의무 및 책임사항을 규정함을 목적으로 합니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제2조 (용어 정의)
                            </dt>
                            <dd>
                                ① “서비스”는 DFOS WEATHER 시스템을 말합니다. <br />
                                ② “고객”은 서비스에 접속하여 일정의 정보를 입력하거나 인증을 받은 후, 회사가 제공하는 서비스를 이용하는 개인 또는 법인, 공공기관 등을 말합니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제3조 (약관 등의 명시와 설명 및 개정)
                            </dt>
                            <dd>
                                ① 회사는 본 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호, 전자우편주소, 사업자등록번호등을 고객이 쉽게 알 수 있도록 서비스의 초기화면에 게시합니다. 단, 약관의 내용은 고객이 연결 화면을 통해 볼 수 있도록 할 수 있습니다. <br />
                                ② 본 약관은 회사가 필요하다고 인정되는 경우 대한민국 법령의 범위 내에서 개정할 수 있습니다. <br />
                                ③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스의 초기화면에 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 단, 고객에게 불리하게 약관내용을 변경하는 경우에는 최소 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 회사는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 고객이 알기 쉽도록 표시합니다. <br />
                                ④ 회사가 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다. 단 이미 계약을 체결한 고객이 개정약관 조항의 적용을 받기를 원하는 뜻을 개정약관의 공지기간 내에 회사에 요청하여 회사의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.
                            </dd>
                        </dl>
                    </div>

                    <div class="dl-group">
                        <div class="dl-tit">
                            2장 서비스 이용
                        </div>
                        <dl>
                            <dt>
                                제4조 (서비스 이용의 신청)
                            </dt>
                            <dd>
                                ① 서비스 이용 신청자(이하 “신청인”)가 약관에 동의한 후 서비스 이용을 신청하면 서비스 이용계약이 성립합니다. <br />
                                ② 서비스 이용 신청 시 신청인은 이메일, 이름을 실제 정보로 제공해야 합니다. 신청인이 불법적으로 가명을 사용하거나 거짓 정보를 제공한 경우에는 약관에 명시된 권리를 누리거나 주장할 수 없으며, 회사는 서비스 계약을 해지할 수 있습니다. <br />
                                ③ 신청인이 서비스 이용 신청 시 제공한 개인 정보는 준거법 및 규정, 개인정보보호 정책에 따라 보호됩니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제5조 (고객에 대한 통지)
                            </dt>
                            <dd>
                                ① 회사가 고객에게 통지해야 하는 경우, 회사는 서비스 이용 신청 시 고객이 등록한 이메일 주소를 이용하여 통지합니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제6조 (서비스 제공)
                            </dt>
                            <dd>
                                ① 서비스는 연중무휴, 1일 24시간 제공을 원칙으로 합니다. 단, 회사가 필요한 경우 또는 IaaS의 장애, 서비스 이용의 폭주 등 불가항력적인 사항으로 인하여 서비스 이용에 지장이 있는 경우 예외적으로 서비스 이용의 전부 또는 일부를 제한할 수 있습니다. <br />
                                ② 회사는 서비스 제공에 필수적인 경우 정기점검을 실시할 수 있습니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제7조 (손해배상)
                            </dt>
                            <dd>
                                ① 회사는 회사의 책임 있는 사유로 월 가용률 구간 미만을 제공하여 고객이 손해를 입은 경우 고객의 청구에 의해 아래와 같이 손해를 배상합니다. <br />
                                ② 고객이 손해배상을 청구하고자 하는 경우 이에 대한 사유, 산출 근거, 장애의 상세 내용을 서면으로 회사에 제출하여야 합니다. <br />
                                ③ 서비스가 서비스 수준 협약에서 제시된 월 가용률을 만족하지 못할 때 아래의 금액을 기준으로 고객과 협의하여 서비스 이용 요금을 할인하여 손해를 배상합니다. <br />
                                월 가용률 : 99% 이상 ~ 99.5% 미만 - 10%, 99% 미만 - 20% <br />
                                ④ 단, 회사가 서비스를 무료로 고객에게 제공하는 기간에는 장애에 대한 손해배상을 하지 않습니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제8조 (서비스 중단)
                            </dt>
                            <dd>
                                ① 회사는 다음에 해당하는 경우에 대해 서비스 제공을 중단할 수 있습니다. <br />
                                1. 서비스 제공과 관련된 IaaS의 장애 또는 정기/비정기 점검 작업 등 불가피한 사유가 발생한 경우 <br />
                                2. 국가적 비상사태, 서비스 이용의 폭주, 천재지변 등 불가피한 사유로 회사가 안정적인 서비스를 제공할 수 없는 경우 <br />
                                ② 회사는 상기 제1항 제1호에 명시된 사항에 대해 사전에 고객에게 서비스 중단을 통지합니다. 단, 회사가 사전에 인지하지 못하거나 통제할 수 없는 사유로 인한 서비스의 중단으로 인하여 사전 통지가 불가능한 경우에는 서비스 중단을 통지하지 않습니다. <br />
                                ③ 회사는 상기 제1항 제2호에 명시된 사항에 대해서는 사전 통지 없이 서비스를 중단할 수 있습니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제9조 (서비스 계약 해지)
                            </dt>
                            <dd>
                                ① 고객이 서비스 이용 계약을 해지하고자 할 경우에는 회사에 전화, 이메일 등의 방법을 통해 회사에게 이를 통지해야 합니다. <br />
                                ② 고객은 서비스 계약 이후 언제든지 계약 해지를 요청할 수 있으며, 회사는 해당 계약해지 요청을 처리합니다. <br />
                                ③ 고객은 서비스 사용을 통해 서버에 저장된 데이터의 백업을 요청할 수 있으며, 회사는 해당 백업 요청을 처리합니다. <br />
                                ④ 회사는 서비스 계약 해지와 동시에 고객의 모든 데이터를 삭제합니다. 삭제된 데이터는 어떠한 이유로든 복구되지 않습니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제10조 (회사의 서비스 계약의 직권 해지)
                            </dt>
                            <dd>
                                ① 회사는 다음에 해당하는 경우에 대해 고객과 협의 없이 서비스 계약을 해지할 수 있습니다. <br />
                                1. 고객이 서비스 이용 신청 시, 불법적으로 가명을 사용하거나 거짓 정보를 제공한 경우 <br />
                                2. 회사의 동의 없이 영리를 목적으로 서비스를 이용하거나 제3자에게 재판매, 재임대하는 경우 <br />
                                3. 기타 관계법령에 위배되거나 회사의 업무를 방해하는 경우
                            </dd>
                        </dl>
                    </div>

                    <div class="dl-group">
                        <div class="dl-tit">
                            제3장 계약당사자의 의무
                        </div>
                        <dl>
                            <dt>
                                제11조 (회사의 의무)
                            </dt>
                            <dd>
                                ① 회사는 안정적이고 지속적인 방식으로 고객에게 서비스를 제공하기 위해 노력합니다. <br />
                                ② 안정적인 서비스 제공에 지장을 주는 장애가 발생되는 경우, 회사는 최대한 빨리 정비 또는 복구하는데 최선을 다합니다. <br />
                                ③ 회사는 서비스 제공과 관련하여 취득한 고객의 개인정보를 고객의 사전 동의 없이 제3자에게 제공할 수 없으며 회사의 서비스 관련 업무 이외의 목적으로 사용할 수 없습니다. 단, 관련법 및 규정에 따라 조사의 목적등으로 법원 또는 기타 사법 기관이 발행하는 영장 등을 통해 고객 개인정보 제공을 요청 받은 경우는 고객의 동의 없이 개인정보를 제공할 수 있습니다. <br />
                                ④ 회사는 고객이 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제12조 (고객의 의무)
                            </dt>
                            <dd>
                                ① 고객은 본 약관 및 관계 법령에서 규정한 사항을 준수해야 합니다. <br />
                                ② 고객은 회사가 서비스 제공에 필요하다고 인정되는 정보를 전자우편으로 제공 받는 것에 동의합니다. <br />
                                ③ 회사의 저작권 및 제3자의 저작권 등 기타 권리를 침해하는 행위를 하지 않아야 합니다. <br />
                                ④ 고객은 서비스를 이용한 영업행위를 할 수 없으며, 이에 따라 발생한 결과에 대해서는 회사가 책임지지 않습니다. <br />
                                ⑤ 고객은 서비스의 이용권한을 타인에게 양도, 증여할 수 없습니다. <br />
                                ⑥ 고객은 고객의 귀책사유로 인해서 회사나 다른 고객이 입은 손해를 배상할 책임이 있습니다.
                            </dd>
                        </dl>
                    </div>

                    <div class="dl-group">
                        <div class="dl-tit">
                            제4장 기타
                        </div>
                        <dl>
                            <dt>
                                제13조 (회사의 면책조항)
                            </dt>
                            <dd>
                                ① 고객이 회사의 서비스 제공으로부터 기대되는 이익을 얻지 못하거나 서비스 이용으로 발생하는 불이익에 대하여 회사는 책임지지 않습니다. <br />
                                ② 회사는 고객들의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임지지 않습니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제14조 (준거법 및 재판 관할)
                            </dt>
                            <dd>
                                ① 회사와 고객간에 제기된 소송은 대한민국 법을 준거법으로 합니다. <br />
                                ② 본 약관은 대한민국 법령에 의하여 규정되고 이행되며, 본 서비스와 관련하여 회사와 고객간에 발생한 분쟁은 민사소송법상의 관할법원에 제기합니다. <br />
                                ③ 대한민국 이외의 지역에서의 재판권은 인정되지 않으며, 본 약관과 관련하여 법률적 분쟁이 발생하는 경우 그 해결의 국지적 범위는 대한민국 영토 내를 전속적 관할로 합니다.
                            </dd>
                        </dl>
                    </div>
                    
                    <div class="dl-group">
                        <div class="dl-tit">
                            부칙
                        </div>
                        <dl>
                            <dd>
                                본 약관은 2021년 4월 26일부터 적용됩니다.
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="agree-row">
                <div class="agree-chk-box">
                    <div class="cbox">
                        <label>
                            <input type="checkbox" [(ngModel)]="isPrivacyPolicyChecked" (change)="toggleCheckedState(isPrivacyPolicyChecked)" />
                            <i></i>
                            <span class="txt">
                                {{ "join.terms.agreePrivacyPolicy" | translate }}
                            </span>
                        </label>
                    </div>
                </div>
                <div class="agree-terms-box">
                    <div class="dl-group">
                        <dl>
                            <dd>
                                주식회사 아이지아이에스(이하 “회사”) 및 DFOS Weather(이하 “서비스”)는 개인정보 보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
                            </dd>
                        </dl>
                    </div>

                    <div class="dl-group">
                        <dl>
                            <dt>
                                제1조 (개인정보의 처리 목적)
                            </dt>
                            <dd>
                                회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. <br />
                                ① 홈페이지 회원가입 및 관리 <br />
                                ② 재화 또는 서비스 제공 <br />
                                ③ 마케팅 및 광고에 활용
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제2조 (개인정보의 처리 및 보유 기간)
                            </dt>
                            <dd>
                                ① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다. <br />
                                ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다. <br />
                                1. 재화 또는 서비스 제공 : 재화 또는 서비스 제공과 관련된 개인정보는 수집 및 이용에 관한 동의일로부터 5년까지 위 이용목적을 위하여 보유 및 이용됩니다. <br />
                                2. 관련 법령 : 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년, 대금결제 및 재화 등의 공급에 관한 기록 : 5년, 계약 또는 청약철회 등에 관한 기록 : 5년
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제3조 (정보주체와 법정대리인의 권리 및 의무와 그 행사방법)
                            </dt>
                            <dd>
                                ① 정보주체는 회사에게 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다. <br />
                                ② 제1항에 따른 권리 행사는 「개인정보 보호법」 시행령 제41조제1항에 따라 서면, 전자우편, FAX 등으로 할 수 있으며 회사는 이에 대해 조치합니다. <br />
                                ③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통해 할 수 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출해야 합니다. <br />
                                ④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의해 정보주체의 권리가 제한 될 수 있습니다. <br />
                                ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 요구할 수 없습니다. <br />
                                ⑥ 회사는 정보주체의 권리에 따른 열람, 정정, 삭제, 처리정지의 요구 시 이를 요구한 자가 본인이거나 정당한 대리인인지 확인하며 그렇지 않은 경우 조치하지 않습니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제4조 (처리하는 개인정보 항목)
                            </dt>
                            <dd>
                                ① 회사는 다음의 개인정보 항목을 처리합니다. <br />
                                1. 홈페이지 회원가입 및 관리 : 이메일, 비밀번호, 이름 <br />
                                2. 재화 또는 서비스 제공 : 이메일, 이름, 서비스 이용 기록, 쿠키, 접속 IP 정보, 결제 기록 <br />
                                3. 마케팅 및 광고에 활용 : 이메일, 서비스 이용 기록
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제5조 (개인정보의 파기)
                            </dt>
                            <dd>
                                ① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다. <br />
                                ② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존해야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스로 옮기거나 저장소를 달리하여 보존합니다. <br />
                                ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다. <br />
                                1. 파기 절차 : 회사는 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다. <br />
                                2. 파기방법 : 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통해 파기합니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제6조 (개인정보의 안전성 확보 조치)
                            </dt>
                            <dd>
                                ① 회사는 개인정보 취급 직원을 최소화하고 개인정보를 관리하는 대책을 교육합니다. <br />
                                ② 회사는 해킹이나 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위해 시스템적인 보안 대책을 수립 및 적용하고, 주기적인 점검을 통해 기술적/물리적으로 감시 및 차단합니다. <br />
                                ③ 이용자의 개인정보는 암호화 되어 저장 및 관리하며, 전송 시에는 원본 데이터를 확인할 수 없는 방법으로 암호화하여 보호합니다. <br />
                                ④ 회사는 개인정보를 처리하는 데이터베이스에 대한 접근 권한 관리를 통해 외부로부터의 무단 접근을 통제합니다.
                            </dd>
                        </dl>
                        <dl>
                            <dt>
                                제7조 (개인정보 자동 수집 장치의 설치 및 운영, 거부에 관한 사항)
                            </dt>
                            <dd>
                                ① 회사는 이용자에게 원활한 서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 “쿠키(cookie)"를 사용합니다. <br />
                                ② 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저에게 보내는 소량의 데이터이며, PC내의 하드디스크에 저장되기도 합니다. <br />
                                ③ 쿠키의 사용 목적은 다음과 같습니다. <br />
                                1. 이용자가 방문한 서비스와 사이트에 대한 방문 및 정상 접속 여부를 파악하여 이용자에게 정상적인 서비스를 제공하기 위해 사용됩니다. <br />
                                2. 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다. <br />
                                ④ 쿠키 저장을 거부할 경우 원활한 서비스 이용에 어려움이 발생할 수 있습니다.
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </article>
    <article class="sign-in-btn">
        <div class="btn-box">
            <a class="cancel-btn" (click)="cancel()">
                {{ "join.terms.prevButton" | translate }}
            </a>
        </div>
        <div class="btn-box">
            <a class="primary-btn" [class.disabled]="!isAllTermsChecked" (click)="next()">
                {{ "join.terms.nextButton" | translate }}
            </a>
        </div>
    </article>
</div>